import { motion } from 'framer-motion';
import { theme } from '../../styles/theme';
import { mq } from '../../styles/mq';

import styled from 'styled-components';

export const StyledDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Toggle = styled.div`
  width: 100%;
  cursor: pointer;
  order: 1;
  font-size: 1.6rem;
  ${mq.xlarge} {
    font-size: 2rem;
  }

  & + *,
  & + * > *:first-child,
  & + * > *:first-child > *:first-child {
    margin-top: 0;
  }
`;

export const ReadMoreButton = styled.span`
  display: block;
  max-width: calc(10 * var(--grid-size) + 9 * var(--gap-size));
  margin: 0 auto;
  font-family: 'Skolar Sans PE condensed';
  font-weight: 800;
  font-variant: small-caps;
  color: ${theme.colors.orange};
`;
